import { EXPRESS_SHIPPING_COST, SHIPPING_COST, INTERNATIONAL_SHIPPING_COST, NZ_COST } from "../config";

const STATE = {
    OVERVIEW: "OVERVIEW",
    PACK: "BOOSTER",
    SEALED: "SEALED",
    CART: "CART",
    SINGLE: "CARD",
    SLAB: "SLAB",
    SUCCESS: "SUCCESS",
    PROMO: "PROMOTION",
    LOGIN: "LOGIN",
    ACC_SETTINGS: "ACCOUNT",
    SETTINGS: "SETTINGS",
    PROFILE: "PROFILE",
    CARD: "CARD",
    PRIVACY_POLICY: "PRIVACY POLICY",
    TERMS_AND_CONDITIONS: "TERMS AND CONDITIONS",
    INFO: "QnA",
    WISHLIST: "WISHLIST",
    ORDERS: "ORDERS",
    COLLECTIONS: "COLLECTIONS",
    COUPONS: "COUPONS",
    ADMIN_TOOLS: "ADMIN_TOOLS",
};

const USER_TYPE = {
    EXISTING: "Existing",
    NEW: "New",
}

const STATES = ["VIC", "NSW", "WA", "QLD", "SA", "ACT","TAS",
];

const CART_STATES = {
  ITEMS:"ITEMS",
  CHECKOUT: "CHECKOUT",
  SUCCESS: "SUCCESS"
}

const USERSTATES = { SIGN:"SIGN",
  REGISTER:"REGISTER",
  LOGIN:"LOGIN",
  PROFILE:"PROFILE",
  COLLECTION:"COLLECTION",
  COUPONS: "COUPONS",
  WISHLIST: "WISHLIST",
  FORGOT: "FORGOT",
};

const PMT = {
    CARD:"CARD",
    PAYID:"PAYID"
};

const CONDITION = {
    NM:"NM",
    LP:"LP",
    MP:"MP",
    HP:"HP",
    DMG:"DMG"
}

const COUNTRY_CODES = [
  { code: "AU", name: "Australia" },
  { code: "US", name: "United States" },
  { code: "GB", name: "United Kingdom" },
  { code: "CA", name: "Canada" },
  { code: "NZ", name: "New Zealand" },
  { code: "DE", name: "Germany" },
  { code: "FR", name: "France" },
  { code: "JP", name: "Japan" },
  { code: "KR", name: "South Korea" },
  { code: "VN", name: "Vietnam" },
  { code: "SG", name: "Singapore" },
  { code: "CN", name: "China" },
//   { code: "IN", name: "India" },
//   { code: "BR", name: "Brazil" },
//   { code: "ZA", name: "South Africa" },
  // Add more as needed
];

const COLLECTION_SET = {
  COL:"COLLECTION",
  SET:"SET",
}

const SHIPPING_COSTS = {
  STANDARD:SHIPPING_COST,
  HOLD:0,
  EXPRESS:EXPRESS_SHIPPING_COST,
  INTERNATIONAL: INTERNATIONAL_SHIPPING_COST,
  NZ: NZ_COST
}

const BADGES = {
  JUST_LISTED:"JUST LISTED",
  SALE:"SALE",
  HOT: "HOT",
  RISING: "RISING",
  LAST_ONE: "LAST ONE",
  MOST_WISHED: "MOST WISHED",
}

  const STOCK_LEVEL = {
    SINGLE: 2,
    SLAB: 1,
    SEALED: 5,
    PACK: 10,
    PROMO: 10,
  };

export { STOCK_LEVEL, USER_TYPE, STATE, STATES, PMT, USERSTATES, CONDITION, COUNTRY_CODES, COLLECTION_SET, CART_STATES, SHIPPING_COSTS, BADGES};